// getRelativeTime.js
'use strict';
import {
  fromUnixTime,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
} from 'date-fns';

/**
 * Get the relative time string
 * @param {number} {unixTimestamp} - the time with unix format
 * @return {string} relative time string
 */
const getRelativeTime = ({ unixTimestamp }) => {
  const date = fromUnixTime(unixTimestamp);
  const now = Date.now();
  const minutes = Math.floor(differenceInMinutes(now, date));

  if (minutes === 0) {
    return '< 1m ago';
  }

  if (minutes < 60) {
    return `${minutes}m ago`;
  }

  const hours = Math.floor(differenceInHours(now, date));

  if (hours < 24) {
    return `${hours}h ago`;
  }

  const days = Math.floor(differenceInDays(now, date));

  return `${days}d ago`;
};

export default getRelativeTime;
